import { NOT_SET } from '../../marketplace/utils/segment/constants';
import trackUser from '../../marketplace/utils/segment/trackUser';
import checkSegmentCookie, {
  SegmentCookieUser,
} from '../../marketplace/utils/segment/checkSegmentCookie';
import { trackEvent } from '../tracking';

type TrackUserOptInUser = {
  permissions?: {
    oneCommerce?: {
      ceo?: {
        access?: boolean;
      };
    };
  };
  userId: string;
  firstName: string | null;
  hashedEmail: string | null;
  lastName: string | null;
} & SegmentCookieUser;

export const trackUserOptIn = (
  email: string,
  user: TrackUserOptInUser | null,
  source: string,
) => {
  checkSegmentCookie(user);
  const traits: any = {
    email,
    acceptsMarketing: true,
    application: 'One Commerce',
    source,
  };
  if (user) {
    const { permissions } = user;
    const isLoggedInAsCeo =
      permissions &&
      permissions.oneCommerce &&
      permissions.oneCommerce.ceo &&
      permissions.oneCommerce.ceo.access;

    // traits.ceoStatus = false;
    traits.ceoId = NOT_SET;

    if (user.firstName && user.firstName !== '') {
      traits.firstName = user.firstName;
    }
    if (user.lastName && user.lastName !== '') {
      traits.lastName = user.lastName;
    }
    if (isLoggedInAsCeo) {
      // traits.ceoStatus = true;
      traits.ceoId = user.userId;
    }
  }
  const idParamsOptIn = {
    type: 'identify',
    userId: email,
    traits,
    integrations: {
      All: true,
      Klaviyo: { confirmOptin: false, listId: process.env.KLAVIYO_LIST_ID },
      Intercom: {
        hideDefaultLauncher: true,
        user_hash: user ? user.hashedEmail : null,
      },
    },
  };
  trackEvent({
    user: { email },
    event: 'Email Subscription Sign-Up',
    properties: {},
  });
  return trackUser(idParamsOptIn);
};
